





















import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { SupportedGame } from '@/api/config'

@Component
export default class MobileGameSelector extends Vue {
  @Prop({ type: String, default: null })
  value!: string

  @Prop({ default: [] })
  games!: SupportedGame[]

  @Prop({ type: String, default: null })
  region!: string

  @Emit('input')
  changeValue(game: string) {
    return game
  }
}
